import { lazy } from 'react';
import { getCorrespondLabel } from '@/utils/global';

const TeachingRoutes = [
    {
        label: '地图详情',
        key: 'learning-maps',
        path: 'learning-maps',
        element: lazy(() => import('@/components/Layout/CommonLayout')),
        children: [
            {
                label: '地图详情',
                key: ':levelId',
                path: ':levelId',
                element: lazy(() => import('@/page/mapDetails'))
            }
        ]
    },
    {
        label: '',
        path: '/:templateId/:businessId',
        key: 'Teaching',
        redirect: '/home',
        element: lazy(() => import('@/components/Layout/CommonLayout')),
        children: [
            {
                label: '项目首页',
                key: 'project',
                path: 'home',
                show: true,
                element: lazy(() => import('@/page/Project/Home/Home'))
            },
            {
                label: '教学活动详情',
                key: 'teach-detail/:teachId',
                path: 'teach-detail/:teachId',
                show: true,
                element: lazy(() => import('@/page/Project/TeachDetail/TeachDetail'))
            },
            {
                label: '公告',
                key: 'notice',
                show: true,
                path: 'notice',
                element: lazy(() => import('@/page/Project/Notice/Notice'))
            },
            {
                label: '必修课',
                key: 'required-course',
                show: true,
                path: 'requiredCourse-two',
                element: lazy(() => import('@/page/Project/RequiredCourse/RequiredCourse'))
            },
            {
                label: '选修课',
                key: 'elective-course',
                show: true,
                path: 'electiveCourses-two',
                element: lazy(() => import('@/page/Project/RequiredCourse/electiveCourses'))
            },
            {
                label: '教学业务',
                key: 'teach-business',
                show: true,
                path: 'teach-business-two',
                element: lazy(() => import('@/page/TeachBusiness/TeachBusiness'))
            },
            {
                label: '成绩',
                key: 'score',
                show: true,
                path: 'score',
                element: lazy(() => import('@/page/Project/Score/Score'))
            },
            {
                label: '证书',
                key: 'certificate',
                show: true,
                path: 'certificate-two',
                element: lazy(() => import('@/page/Project/Certificate/Certificate'))
            },
            {
                label: getCorrespondLabel('102'),
                key: 'examination-list',
                show: true,
                path: 'examination-two',
                element: lazy(() => import('@/page/Project/RequiredCourse/examination'))
            },
            {
                label: getCorrespondLabel('105'),
                key: 'school-assignment',
                show: true,
                path: 'schoolAssignment-two',
                element: lazy(() => import('@/page/Project/RequiredCourse/schoolAssignment'))
            },
            {
                label: getCorrespondLabel('106'),
                key: 'trainings-achievement',
                show: true,
                path: 'trainingAchievements-two',
                element: lazy(() => import('@/page/Project/RequiredCourse/trainingAchievements'))
            },
            {
                label: getCorrespondLabel('113'),
                key: 'community',
                show: true,
                path: 'community-two',
                element: lazy(() => import('@/page/Project/RequiredCourse/Community'))
            },
            {
                label: getCorrespondLabel('109'),
                key: 'activity',
                show: true,
                path: 'activity-two',
                element: lazy(() => import('@/page/Project/RequiredCourse/activity'))
            }
        ]
    }
];
export default TeachingRoutes;
